import React, { useState, useRef } from 'react';
import { 
  Button, 
  Popover,
  Typography, 
  Grid, 
  Divider,
  Paper
} from '@mui/material';

export const ProjectSchemeInformation = ({ projectData }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const buttonRef = useRef(null);

  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'project-info-popover' : undefined;

  const ellipsisText = {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    display: 'block'
  };

  return (
    <Grid>
      <Button 
        variant="outlined" 
        size="small" 
        sx={{ 
            marginRight: '4px',
            marginLeft: '4px',
            borderRadius: '8px',
            textTransform: 'none',
            fontSize: '14px',
            padding: '2px 8px',
            minWidth: 'auto',  // Allow button to shrink
            whiteSpace: 'nowrap',  // Keep text on one line
            overflow: 'hidden',
            textOverflow: 'ellipsis',  // Add ellipsis if text gets cut
        }}
        onClick={handleOpen}
        ref={buttonRef}
      >
        <Typography 
            variant="caption"
            sx={{ ...ellipsisText }}
        >
        Project Information
        </Typography>
    </Button>

      {/* Popover */}
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        slotProps={{
            paper: {
              sx: {
                width: 360,
                mt: 0.5,
                borderRadius: 2,
                boxShadow: 3,
                overflow: 'visible',
              },
            },
        }}
      >
        <Paper sx={{ position: 'relative' }}>
          {/* Popover Header */}
          <Grid sx={{ 
            p: 2, 
            pb: 1.5, 
            borderColor: 'divider',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
          }}>
            <Typography variant="h6" fontWeight="600">
              Project Details
            </Typography>
          </Grid>

          {/* Popover Content */}
          <Grid sx={{ p: 2 }}>
            <Grid sx={{ display: 'flex', mb: 1 }}>
              <Grid sx={{ flexGrow: 1 }}>
                {/* Project Details Grid */}
                <Grid container spacing={1}>
                  <Grid item xs={5}>
                    <Typography variant="body2" color="text.secondary">
                      Project Name
                    </Typography>
                  </Grid>
                  <Grid item xs={7}>
                    <Typography variant="body2" fontWeight="bold">
                      {projectData.name}
                    </Typography>
                  </Grid>
                    <Grid item xs={12}>
                        <Divider sx={{ mb: 1 }} />
                    </Grid>
                  <Grid item xs={5}>
                    <Typography variant="body2" color="text.secondary">
                      Project Type
                    </Typography>
                  </Grid>
                  <Grid item xs={7}>
                    <Typography variant="body2" fontWeight="bold">
                      {projectData.type}
                    </Typography>
                  </Grid>
                  <Grid item xs={12}>
                        <Divider sx={{ mb: 1 }} />
                    </Grid>
                  <Grid item xs={5}>
                    <Typography variant="body2" color="text.secondary">
                      Project Phase
                    </Typography>
                  </Grid>
                  <Grid item xs={7}>
                    <Typography variant="body2" fontWeight="bold">
                      {projectData.phase}
                    </Typography>
                  </Grid>
                  <Grid item xs={12}>
                        <Divider sx={{ mb: 1 }} />
                    </Grid>
                  <Grid item xs={5}>
                    <Typography variant="body2" color="text.secondary">
                      Target Date
                    </Typography>
                  </Grid>
                  <Grid item xs={7}>
                    <Typography variant="body2" fontWeight="bold">
                      {projectData.startDate}
                    </Typography>
                  </Grid>
                  <Grid item xs={12}>
                        <Divider sx={{ mb: 1 }} />
                    </Grid>
                  <Grid item xs={5}>
                    <Typography variant="body2" color="text.secondary">
                      Project Location
                    </Typography>
                  </Grid>
                  <Grid item xs={7}>
                    <Typography variant="body2" fontWeight="bold">
                      {projectData.location}
                    </Typography>
                  </Grid>
                  <Grid item xs={12}>
                        <Divider sx={{ mb: 1 }} />
                    </Grid>
                </Grid>
              </Grid>
            </Grid>

            <Typography variant="body2" color="text.secondary">
                Description
            </Typography>
            <Typography variant="caption" color="text.secondary" sx={{ lineHeight: 1.6 }}>
              {projectData.description}
            </Typography>
          </Grid>
        </Paper>
      </Popover>
    </Grid>
  );
};
